import "@blocknote/core/fonts/inter.css";
import { useCreateBlockNote } from "@blocknote/react";
import React, { useEffect, useRef } from "react";
import { BlockNoteView } from "@blocknote/mantine";
import { uploadAttachment } from "../../../services/attachments";
import "@blocknote/mantine/style.css";
const apiUrl = process.env.REACT_APP_API_URL;

async function uploadFile(file) {
  let data = new FormData();
  data.append("attachments", file);

  const res = await uploadAttachment(data, {
    headers: {
      "Content-Type": "multipart/form-data",
      // "Content-Length": blob.size,
    },
  });

  const url = `${apiUrl}/${res?.data?.[0].filePath}`;

  return url;
}

export default function MyEditor({
  onChangeHandler,
  initialContent,
  readOnly = false,
}) {
  const editor = useCreateBlockNote({ uploadFile });
  const hasInitialized = useRef(false); // ✅ Add ref to prevent reloading on re-renders

  useEffect(() => {
    async function loadInitialHTML() {
      if (hasInitialized.current || !initialContent) return;
      const blocks = await editor.tryParseMarkdownToBlocks(initialContent);
      editor.replaceBlocks(editor.document, blocks);
      hasInitialized.current = true; // ✅ mark as initialized
    }
    loadInitialHTML();
  }, [editor, initialContent]);

  const handleChange = async () => {
    if (!editor) return;
    const markText = await editor.blocksToMarkdownLossy(editor.document);
    onChangeHandler?.(markText);
  };

  return (
    <div>
      <div
        style={{
          color: "#94a3b8",
          fontSize: "15px",
          fontStyle: "italic",
          margin: "10px 0",
        }}
      >
        Type '/' to get menu for functionalities
      </div>
      <BlockNoteView
        editor={editor}
        theme="light"
        editable={!readOnly}
        onChange={handleChange}
        className="border rounded py-4"
        style={{ height: !readOnly ? "300px" : "auto", overflowY: "auto" }}
      />
    </div>
  );
}
